import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import Auth from './model/Auth'

import Pusher from 'pusher-js';

import VueGmaps from 'vue-gmaps'
Vue.use(VueGmaps, {
  key: 'AIzaSyCA7gKzVmZmvr_jM750jVl96PAynUHHXuQ'
})

window.axios = require('axios');


window.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let baseUrlAxios = 'https://reservation-api.savva-libkin.com';
window.axios.defaults.baseURL = baseUrlAxios + '/api/';
window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
};

window.axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (403 === error.response.status) {
    bus.$emit('notificationAlert',{
      text : 'У вас недостаточно прав',
      color: '#e35139'
    });
    setTimeout(() => {
      history.go(-1);
    }, 1000)
  } else {
    return Promise.reject(error);
  }
});

Vue.config.productionTip = false
window._ = require('lodash')
window.bus = new Vue();
window.auth = new Auth()


// Enable pusher logging - don't include this in production
Pusher.logToConsole = true;

window.pusher = new Pusher('662c34e5043cc34a443b', {
  cluster: 'eu'
});



new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
